import { LOCAL_CONSTANT } from "../page/Const";
export const getStaffNoList = (target: string, params: any) => {
    let staffNoList: any = [];
    let jsonStaffMasterObj = [];

    switch (target) {
        case "requestEmail_5mOutsideMarketCut_D002":
            jsonStaffMasterObj = JSON.parse(params.staffMasterObj);
            jsonStaffMasterObj.map((e: any) => {
                if (
                    LOCAL_CONSTANT.RR_DEPARTMENT.includes(
                        e.department_code_oa
                    ) &&
                    e.job_category_code_oa === "230"
                ) {
                    staffNoList.push(e.staff_number);
                }
            });
            staffNoList.push(params.userData.staff_number);
            break;
        case "requestEmail_5mOutsideMarketCut_D004":
            jsonStaffMasterObj = JSON.parse(params.staffMasterObj);
            jsonStaffMasterObj.map((e: any) => {
                if (
                    LOCAL_CONSTANT.RR_DEPARTMENT.includes(
                        e.department_code_oa
                    ) &&
                    ["101", "102"].includes(e.job_category_code_oa)
                ) {
                    staffNoList.push(e.staff_number);
                }
            });
            break;
        case "requestEmail_5mOutsideMarketCut_D006":
            staffNoList.push(params.planAreaInfoData.RM_code);
            staffNoList.push(params.userData.staff_number);
            break;
        case "requestEmail_5mOutsideMarketCut_D007":
            jsonStaffMasterObj = JSON.parse(params.staffMasterObj);
            jsonStaffMasterObj.map((e: any) => {
                if (
                    e.department_code_oa ===
                        params.planAreaInfoData.top_department_code_oa &&
                    ["101", "102"].includes(e.job_category_code_oa)
                ) {
                    staffNoList.push(e.staff_number);
                }
            });
            break;
        case "returnEmail_5mOutsideMarketcut":
            staffNoList.push(params.userData.staff_number);
            break;
        case "reference":
            // 参考値算出押下、確定依頼押下
            jsonStaffMasterObj = JSON.parse(params.staffMasterObj);
            jsonStaffMasterObj.map((e: any) => {
                if (
                    e.department_code_oa ===
                        params.planAreaInfoData.district_code_oa &&
                    e.job_category_code_oa === "230"
                ) {
                    staffNoList.push(e.staff_number);
                }
            });
            break;
        case "addSurvey":
            jsonStaffMasterObj = JSON.parse(params.staffMasterObj);
            jsonStaffMasterObj.map((e: any) => {
                if (
                    ["950001"].includes(e.department_code_oa) &&
                    ["101", "102"].includes(e.job_category_code_oa)
                ) {
                    staffNoList.push(e.staff_number);
                }
            });
            break;
        case "requestCommentAddSurvey":
            jsonStaffMasterObj = JSON.parse(params.staffMasterObj);
            jsonStaffMasterObj.map((e: any) => {
                if (
                    LOCAL_CONSTANT.RR_DEPARTMENT.includes(
                        e.department_code_oa
                    ) &&
                    e.job_category_code_oa === "230"
                ) {
                    staffNoList.push(e.staff_number);
                }
            });
            break;
    }

    return staffNoList;
};
